import { Translation } from '@modeso/aumico-lib-core-fe';

export interface TranslationResponse {
    id: string;
    translations: Translation;
    totalTranslations?: Translation;
}
